import PropTypes from 'prop-types'
import { GridArea } from '@pretamanger/component-library'
import { areas } from './page-with-side-nav-grid'
import {
  PageWithSideNavGrid,
  SideNavGridArea
} from '#src/page/components/layout/styles'

const PageWithSideNav = ({
  children,
  className,
  heading,
  sideNav,
  isStickyMobileNav
}) => {
  return (
    <PageWithSideNavGrid
      areas={areas}
      className={className}
      isStickyMobileNav={isStickyMobileNav}
    >
      <GridArea name='heading'>{heading}</GridArea>
      <SideNavGridArea
        isStickyMobileNav={isStickyMobileNav}
        data-testid='category-nav'
        name='side-nav'
      >
        {sideNav}
      </SideNavGridArea>
      <GridArea name='body'>{children}</GridArea>
    </PageWithSideNavGrid>
  )
}

PageWithSideNav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  heading: PropTypes.node,
  sideNav: PropTypes.node.isRequired,
  isStickyMobileNav: PropTypes.bool
}

PageWithSideNav.defaultProps = {
  heading: null,
  isStickyMobileNav: false
}

export default PageWithSideNav
